import type { ComponentProps } from 'react';
import { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';

import { useAppDispatch } from '@/store';
import { setHeaderConfig } from '@/store/app.slice';

import ErrorTemplate from './error-template';

type IProps = Omit<ComponentProps<typeof ErrorTemplate>, 'type'>;

const NotFound: React.FC<IProps> = ({ ...props }) => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(
      setHeaderConfig({
        title: '404',
        helmetTitle: '404'
      })
    );
    return () => {
      dispatch(setHeaderConfig({}));
    };
  }, []);

  return (
    <>
      <Helmet title="404" />
      <ErrorTemplate type="404" {...props} />
    </>
  );
};

export default NotFound;
